/**
 * Enum for lifestyle types i.e lifestyle images, lifestyle 360...
 */
export const LIFESTYLE_TYPE={
    lifestyle_images: 'lifestyle_images',
    lifestyle_360:'lifestyle_360'
} 